import request from "_private/utils/request";

/**
 * 司机下拉树
 * @param {*} data
 */
export function FetchDriverTreeList() {
    return request({
        url: "/tms/driver/getDriverListByCorpId",
        method: "post"
    });
}

/**
 * 初始化车辆树
 */
export function FetchFindVehicleTree() {
    return request({
        url: "/base/vehicle/vehicleTree",
        method: "post"
    });
}

/**
 * 删除文件
 * @param {*} data
 */
export function DeleteFile(data) {
  return request({
    url: "/app/file/deleteFile",
    method: "post",
    data
  });
}

// 根据父级获取地区下拉框
export function FetchGetArea(parentId, type) {
  return request({
    url: "/base/registered/getArea?parentId=" + parentId + "&type=" + type,
    method: "get"
  });
}
